import React from "react";
import PropTypes from "prop-types";

//interface IDialogCloseButtonProps extends HTMLAttributes<HTMLDivElement> {
interface IDialogCloseButtonProps {
  //component?: Function | string;
  component?: any;
  className?: any;
  onClick: Function | undefined;
}

//interface IDialogCloseButtonStates extends HTMLAttributes<HTMLDivElement> {}
interface IDialogCloseButtonStates {}

class DialogCloseButton extends React.Component<
  IDialogCloseButtonProps,
  IDialogCloseButtonStates
> {
  static propTypes: PropTypes.InferProps<IDialogCloseButtonProps>;

  static defaultProps = {
    component: "button",
    className: ""
  };

  render() {
    const { component: Tag, children, ...props } = this.props;

    return (
      <Tag {...props} onClick={props.onClick}>
        {children}
      </Tag>
    );
  }
}

export default DialogCloseButton;
